<template>
	<v-dialog v-model="dialogState" persistent width="500">
		<v-card>
			<v-card-title class="headline primary white--text" primary-title>
				{{ header }}
			</v-card-title>

			<v-card-text>
				{{ content }}
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="success" flat @click="action">
					Zamknij
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
  name: "ContestOfferInfoDialog",

  data () {
    return {
      dialogState: false,
    };
  },

  watch: {
    dialogModel: function () {
      this.dialogState = this.dialogModel;
    },

    dialogState: function (val) {
      if (!val) this.$emit("close-info");
    }
  },

  props: {
    dialogModel: Boolean,
    header: String,
    content: String,
    action: Function,
  },
};
</script>

<style scoped>

</style>